import React from 'react';
import { Spinner } from 'react-bootstrap';

import { SuperAdminDateRangeFilter } from './SuperAdminDateRangeFilter';
import type { DateRangeState } from './dateRangeUtils';

export type { DateRangeState } from './dateRangeUtils';
export {
  buildDefaultLastDaysRange,
  initDefaultLastDaysRange,
  toDateEnd,
  toDateStart,
} from './dateRangeUtils';

type TopCompaniesReportShellProps = {
  title: string;
  totalText: string;
  totalClassName: string;
  loading: boolean;
  filters: DateRangeState;
  setFilters: React.Dispatch<React.SetStateAction<DateRangeState>>;
  onApply: () => void;
  onClear: () => void;
  spinnerVariant: 'primary' | 'success';
  children: React.ReactNode;
};

export const TopCompaniesReportShell: React.FC<
  TopCompaniesReportShellProps
> = ({
  title,
  totalText,
  totalClassName,
  loading,
  filters,
  setFilters,
  onApply,
  onClear,
  spinnerVariant,
  children,
}) => {
  return (
    <div>
      <SuperAdminDateRangeFilter
        filters={filters}
        setFilters={setFilters}
        onApply={onApply}
        onClear={onClear}
      />

      <div className="d-flex align-items-baseline gap-3 mb-4">
        <h5 className="mb-0">{title}</h5>
        <span className="text-muted">
          Łącznie: <strong className={totalClassName}>{totalText}</strong>
        </span>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center mt-4">
          <Spinner animation="border" variant={spinnerVariant} />
        </div>
      ) : (
        children
      )}
    </div>
  );
};
